export { default } from "./CharacterThumbnail";
